export default [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index'),
      meta: {
        title: '恋TA系统-登录'
      }
    },
    {
      path: '/main',
      name: 'main',
      component: () => import('@/views/main/index'),
      meta: {
        title: '恋TA系统-人员信息'
      }
    },
    
   

]
  